import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import EmptyDataMessage from './EmptyDataMessage.component';
import _ from 'lodash';
import { departmentColors } from '../../../module/yachtDashboard/conf/Data.conf';
import { DashboardDetail } from '../../detail/DashboardDetail';
import { DetailConf } from '../../../module/yachtDashboard/conf/logbook/Detail.conf';

const LogbookTabContent = ({ logbooks, contactOnBoard }) => {
  const { fields, formatValue } = DetailConf;

  return (
    <Box sx={{ minHeight: '55vh' }}>
      {!_.isEmpty(logbooks) ? (
        logbooks.map((logbook) => {
          const departmentName =
            logbook.attributes?.id_department?.data?.attributes
              ?.name_department || '';
          const departmentColor = departmentName
            ? departmentColors[departmentName]
            : 'black';

          const colorTab = departmentColor || departmentColors?.DEFAULT_TAB;

          const data = {
            ...logbook,
            attributes: {
              ...logbook?.attributes,
              id_supplier: {
                data: {
                  attributes: {
                    ..._.get(logbook, 'attributes.id_supplier.data.attributes'),
                    company_name:
                      _.get(
                        logbook,
                        'attributes.id_supplier.data.attributes.company_name'
                      ) || '-',
                  },
                },
              },
            },
            contactOnBoard,
          };

          return (
            <Link
              to={`/logbook/${logbook.id}`}
              key={logbook.id}
              style={{ textDecoration: 'none' }}
            >
              <DashboardDetail
                fields={fields}
                data={data}
                render={formatValue}
                colorTab={colorTab}
                hasHeader
                departmentColor={departmentColor}
                departmentName={departmentName}
              />
            </Link>
          );
        })
      ) : (
        <EmptyDataMessage message='No logbooks found' />
      )}
    </Box>
  );
};

export default LogbookTabContent;
